module.exports = __webpack_public_path__ + "img/gc_03.4d383cd4.png";